<template>
<v-app>

  <v-container>
  <v-row class="mt-5 pt-5 mb-5">
  <v-col md3="md3"></v-col>
  <v-col md6="md6" xs12="xs12" class="mt-2">

  <!-- <div class="display-3">&nbsp;</div> -->
  <div class="display-2">{{title}}</div>
    <blockquote style="border-left: 0px; padding-left: 0rem;">
      <v-icon class="display-1 primary--text pr-2" style="vertical-align: bottom">people</v-icon>
      {{subtitle}}
    </blockquote>
<!--
    <v-btn primary v-bind:loading="loading" v-on:click.native="loading = true" v-bind:disabled="loading"
      >{{submit}}
    </v-btn>
 -->
    <v-snackbar :timeout="error.timeout" v-model="error.show" :top="true">
        {{error.message}}
        <v-btn flat class="blue--text" @click.native="error.show = false">Chiudi</v-btn>
    </v-snackbar>

  <v-stepper v-model="stage" vertical class="text-xs-left">

    <v-stepper-step step="1" v-bind:complete="stage > 1">
      I tuoi dati anagrafici
    </v-stepper-step>
    <v-stepper-content step="1">

      <v-text-field v-for="m in member.personal"
        :label="m.label" v-model="m.data" :key="m.label" :type="m.type">
      </v-text-field>

      <v-btn primary @click.native="nextStep('personal')">{{next}}</v-btn>
      <v-btn flat @click.native="stage--">{{back}}</v-btn>
    </v-stepper-content>

    <v-stepper-step step="2" v-bind:complete="stage > 2">
      La tua residenza
    </v-stepper-step>
    <v-stepper-content step="2">

      <v-text-field v-for="m in member.address"
        :label="m.label" v-model="m.data" :key="m.label" :type="m.type">
      </v-text-field>

      <v-btn primary @click.native="nextStep('address')">{{next}}</v-btn>
      <!-- <v-btn primary @click.native="stage++">{{next}}</v-btn> -->
      <v-btn flat @click.native="stage--">{{back}}</v-btn>
    </v-stepper-content>

    <v-stepper-step step="3">
      Adesione allo statuto
    </v-stepper-step>
    <v-stepper-content step="3">

      <p style="font-size: 1.2rem" class="text-xs-left">
        Dichiaro di aver preso visione dello Statuto dell'Associazione e di accettarlo e rispettarlo in ogni suo punto.</p>
        <p><a href="https://drive.google.com/uc?export=download&id=0ByYab0ydL41gbnQ1NWQ0ZmhnaDQ">Leggi lo statuto di 5pani2pesci</a></p>



      <v-checkbox primary v-model="member.accept.statute" class="ml-3"
      label="Accetto"/>

      <p style="font-size: 1.2rem" class="text-xs-left">
        Acconsento al trattamento dei dati personali ai sensi dell'art. 13 D.lgs. n. 196/2003</p>

      <v-checkbox primary v-model="member.accept.ordinary" class="ml-3"
      label="Accetto" />

      <p style="font-size: 1.2rem" class="text-xs-left">
        Autorizzo la fotografia e la ripresa della mia immagine ed il suo utilizzo per i fini istituzionali di 5pani2pesci</p>

      <v-checkbox primary v-model="member.accept.images" class="ml-3"
      label="Accetto" />

      <v-btn primary v-bind:loading="loading" v-bind:disabled="loading" @click.native="submitMembership()" >
        {{submit}}
      </v-btn>
      <!-- <v-btn primary @click.native="submitMembership()">{{submit}}</v-btn> -->
      <!-- <v-btn primary @click.native="nextStep('accept')">{{next}}</v-btn> -->
      <!-- <v-btn primary @click.native="memberRegistration()">{{submit}}</v-btn> -->
       <v-btn flat @click.native="stage--">{{back}}</v-btn>

    </v-stepper-content>
  </v-stepper>

</v-col>
</v-row>
</v-container>

<v-card class="primary mt-0" height="200px" />

</v-app>
</template>

<script>
// Firebase
import firebase from '../modules/firebase'
// Locale
import locale from '../modules/locale'
// Store
import store from '../modules/store'

export default {
  data () {
    return {
      store,
      // title: 'Benvenuto!',
      // subtitle: 'In questa pagina richiedi l\'iscrizione all\'associazione 5pani2pesci in qualità di socio',
      title: 'Hai quasi finito!',
      subtitle: 'Completa la tua iscrizione inserendo tutte le informazioni',
      submit: 'Invia',
      next: 'Avanti',
      back: 'Indietro',
      loading: false,
      stage: 1,
      // stage: 3,
      member: {
        uid: '',
        personal: {
          name: {data: '', label: 'Nome e Cognome', type: 'text'},
          cf: {data: '', label: 'Codice Fiscale', type: 'text'},
          birthday: {data: '', label: 'Data di nascita (gg/mm/yyyy)', type: 'text'},
          city: {data: '', label: 'Luogo di nascita', type: 'text'}
        },
        address: {
          street: {data: '', label: 'Via', type: 'text'},
          postal: {data: '', label: 'Codice postale', type: 'text'},
          city: {data: '', label: 'Città', type: 'text'},
          mobile: {data: '', label: 'Telefono', type: 'text'}
        },
        accept: {
          ordinary: false,
          statute: false,
          images: false
        }
      },
      error: {
        show: false,
        message: '',
        timeout: 4000
      }
    }
  },
  methods: {
    nextStep: function (type) {
      var inpData = this.member[type]
      // var nextStepOk = false

      // All required
      var reqTest = []
      for (var key in inpData) {
        reqTest.push(!!inpData[key].data)
      }
      var allRequired = reqTest.every((kk) => { return kk })

      // Extra
      if (allRequired) {
        this.stage++
      } else {
        this.error.message = 'Tutti i campi sono obbligatori'
        this.error.show = true
      }
    },
    submitMembership: function () {
      this.loading = true
      var data = this.member.accept
      var allRequired = Object.keys(data).every((kk) => { return data[kk] })
      if (allRequired) {
        firebase.auth().onAuthStateChanged((user, error) => {
          if (user) {
            var member = {
              // membership: {
              status: 'submitted', // incomplete // submitted // accepted // active // inactive
              requested: locale.today(),
              accepted: '',
              payment: {},
              type: 'ordinario',
              // contact: {
              name: this.member.personal.name.data,
              email: user.email,
              mobile: this.member.address.mobile.data,
              // personal: {
              cf: this.member.personal.cf.data,
              birthday: this.member.personal.birthday.data,
              birthcity: this.member.personal.city.data,
              // address: {
              street: this.member.address.street.data,
              postal: this.member.address.postal.data,
              city: this.member.address.city.data
            }
            return new Promise((resolve, reject) => {
              member
              // firebase.database().ref('members/users/').child(user.uid).update(member)
              setTimeout(() => {
                firebase.database().ref('members/users/').child(user.uid).update(member)
                resolve()
              }, 1000)
              // resolve()
            })
            // .then(() => {
            //   this.$router.push({name: 'Main', query: {status: 'submitted'}})
            // })
            .catch(() => {
              console.error('Firebase update error')
            })
            // console.log('1' + this.store.user.membership.status)
            // this.store.user.membership.status = 'submitted'
            // console.log('2' + this.store.user.membership.status)
            // this.$router.push({name: 'Main', query: {status: 'submitted'}})
            // return new Promise(function (resolve, reject) {
            //   setTimeout(() => { resolve() }, 1000)
            // })
            // .then(() => {
            //   console.log(this.$router)
            //   this.$router.push({name: 'Main', query: {status: 'submitted'}})
            // })
            // .catch(() => {
            //   console.error('Router push went wrong')
            // })
          }
        })
      } else {
        this.error.message = 'È obbligatorio accettare tutti i punti'
        this.error.show = true
        setTimeout(() => { this.loading = false }, 200)
      }
    }
  }
}
</script>

<style scoped>
div.stepper__content{
  margin-left: 1rem;
  padding-right: 2.2rem;
}
div.stepper__step {
  /*margin-left: 0;*/
  padding-left: 0.2rem;
}
div.stepper.stepper--vertical {
  box-shadow: none;
}

label {
  font-size: 0.5rem;
}

/*div.stepper__step--active span.stepper__step__step {
    background: red;
    width: 100px;
}
div.stepper__label {
  color: red;
}*/
</style>

<!--
<style scoped lang="stylus">
$theme := {
  primary: pink
}
</style>
-->

<style scoped>
blockquote{
  border-left: 0px;
  padding-left: 0rem;
}
.fade-enter-active, .fade-leave-active {
transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
opacity: 0
}
</style>



// WEBPACK FOOTER //
// Membership.vue?243f71d8